<template>
  <div class="px-3 py-3 filter-sidebar">
    <div class="title mb-3">{{ $t("filter-by") }}</div>
    <base-multi-select
      class="mb-3"
      :options="status_options"
      label="trip-status"
      placeholder="search"
      field="status"
      :value="payload.selected_journey_status"
      :small="true"
      @change-value="setValue"
    >
    </base-multi-select>
    <hr />
    <base-multi-select
      v-if="!$store.getters['enums/user_info'].branch"
      name="branch"
      label="branch"
      :options="$store.getters['enums/branch_enums']"
      placeholder="search"
      field="branch"
      :value="payload.branch"
      :small="true"
      @change-value="setValue"
    />
    <base-multi-select
      label="service-category"
      name="service_category"
      :options="$store.getters['enums/service_category_enums']"
      placeholder="search"
      field="service_category"
      :value="payload.service_category"
      :small="true"
      @change-value="setValue"
    />
    <base-multi-select
      name="reservation-category"
      label="reservation-category"
      :options="$store.getters['enums/reservation_category_enums']"
      placeholder="search"
      field="category"
      :value="payload.category"
      @change-value="setValue"
      :small="true"
    />
    <base-input
      name="contract"
      :rules="{
        positive: true,
        numeric: true,
      }"
      placeholder="contract-id"
      label="contract-id"
      type="number"
      field="contract"
      :value="payload.contract"
      @change-value="setValue"
      :small="true"
    />
    <base-input
      name="route"
      :rules="{
        positive: true,
        numeric: true,
      }"
      placeholder="route-id"
      label="route-id"
      type="number"
      field="route"
      :value="payload.route"
      @change-value="setValue"
      :small="true"
    />
    <div class="label mb-2 mt-3">{{ $t("trip-from-date") }}</div>
    <div class="row">
      <div class="col-6">
        <div class="sub-label">{{ $t("start-date") }}</div>
        <base-date-time-picker
          :id="start_date_modal_id"
          name="start_date"
          :timePicker="false"
          date_field="start_date"
          :value="payload"
          @change-value="setValue"
        ></base-date-time-picker>
      </div>
      <div class="col-6">
        <div class="sub-label">{{ $t("end-date") }}</div>
        <base-date-time-picker
          :id="end_date_modal_id"
          name="start_date_end"
          :timePicker="false"
          date_field="start_date_end"
          :value="payload"
          :minDate="new Date(payload.start_date)"
          @change-value="setValue"
          :position="isLangRtl ? 'right' : 'left'"
        ></base-date-time-picker>
      </div>
    </div>
    <div class="label mb-2">{{ $t("trip-to-date") }}</div>
    <div class="row">
      <div class="col-6">
        <div class="sub-label">{{ $t("start-date") }}</div>
        <base-date-time-picker
          :id="start_date_modal_id"
          name="end_date"
          :timePicker="false"
          date_field="end_date"
          :value="payload"
          @change-value="setValue"
        ></base-date-time-picker>
      </div>
      <div class="col-6">
        <div class="sub-label">{{ $t("end-date") }}</div>
        <base-date-time-picker
          :id="end_date_modal_id"
          name="end_date_to"
          :timePicker="false"
          date_field="end_date_to"
          :value="payload"
          :minDate="new Date(payload.end_date)"
          @change-value="setValue"
          :position="isLangRtl ? 'right' : 'left'"
        ></base-date-time-picker>
      </div>
    </div>
    <hr />
    <div class="label mb-2">{{ $t("time") }}</div>
    <div class="row">
      <div class="col-6">
        <div class="sub-label">{{ $t("start-time") }}</div>
        <base-time-picker
          field="start_time"
          :value="payload.start_time"
          @change-value="setValue"
          :dropdown_meridiem_picker="true"
          :disabled="!payload.start_date && !payload.start_date_end"
        />
      </div>
      <div class="col-6">
        <div class="sub-label">{{ $t("end-time") }}</div>
        <base-time-picker
          field="end_time"
          :value="payload.end_time"
          @change-value="setValue"
          :dropdown_meridiem_picker="true"
          :disabled="!payload.end_date && !payload.end_date_to"
        />
      </div>
    </div>
    <div>
      <base-button
        variant="primary"
        @click="getData"
        v-b-toggle.sidebar-backdrop
      >
        {{ showDownloadFilters ? $t("export") : $t("filters") }}
      </base-button>
      <div
        class="reset-link mt-3"
        v-b-toggle.sidebar-backdrop
        @click="$emit('reset-data')"
      >
        {{ showDownloadFilters ? $t("cancel") : $t("reset-filters") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["payload", "showDownloadFilters"],
  emits: ["filter-data", "reset-data"],
  data() {
    return {
      status_options: [
        { text: this.$t("Booking-Confirmed"), value: "Booking-Confirmed" },
        { text: this.$t("Booking-Re-Assigned"), value: "Booking-Re-Assigned" },
        { text: this.$t("Booking-Un-Assigned"), value: "Booking-Un-Assigned" },
        { text: this.$t("Booking-Pending"), value: "Booking-Pending" },
        { text: this.$t("Booking-Cancelled"), value: "Booking-Cancelled" },
        {
          text: this.$t("Booking-Cancelled-Note"),
          value: "Booking-Cancelled-Note",
        },
        { text: this.$t("Trip-Started"), value: "Trip-Started" },
        {
          text: this.$t("Trip-Arrived-At-Pickup-Location"),
          value: "Trip-Arrived-At-Pickup-Location",
        },
        {
          text: this.$t("Trip-Passenger-Picked-Up"),
          value: "Trip-Passenger-Picked-Up",
        },
        {
          text: this.$t("Trip-Arrived-To-Dropped-Off"),
          value: "Trip-Arrived-To-Dropped-Off",
        },
        {
          text: this.$t("Trip-Passenger-Dropped-Off"),
          value: "Trip-Passenger-Dropped-Off",
        },
        { text: this.$t("Trip-Completed"), value: "Trip-Completed" },
        { text: this.$t("Trip-Completed-Note"), value: "Trip-Completed-Note" },
      ],
      start_date_modal_id: "start-date-picker-modal",
      end_date_modal_id: "end-date-picker-modal",
      start_date_context: {},
      end_date_context: {},
    };
  },
  methods: {
    setValue(val, field) {
      this["payload"][field] = val;
    },
    async getData() {
      if (this.showDownloadFilters) {
        this.$emit("download-trips");
      }
      this.$emit("filter-data");
    },
  },
  created() {
    this.$store.dispatch("enums/GET_RESERVATION_CATEGORY_ENUMS");
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
    this.$store.dispatch("enums/GET_SERVICE_CATEGORY_ENUMS");
  },
};
</script>
